import React from "react";
import { IconProps } from "./IconProps";

const Close: React.FC<IconProps> = ({
    size = 22,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <path
                d="M15 5L5 15M5 5L15 15"
                stroke={color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Close;
